import React, {useEffect, useState} from "react";
import notfound from "./images/sticker-13.png";
import {getStickerSrc} from "../../../service/feed.sevice";

type StickerCommentProps = {
    stickerType: string,
    stickerId: string
}

const StickerComment = (props: StickerCommentProps) => {
  const [imageSrc, setImageSrc] = useState<string>();

  const onLoad = (event: any) => {
    event.target.classList.add("loaded");
  };
  const onError = (event: any) => {
    event.target.classList.add("loaded");
    setImageSrc(notfound);
  };

  useEffect(() => {
    let stickerSrc = getStickerSrc(props.stickerId);
    setImageSrc(stickerSrc);
  }, [props.stickerType, props.stickerId])

  return (
    // <div style={{ width: "30%", height: "30%" }}>
    //   <img
    //     width="100%"
    //     height="100%"
    //     src={imageSrc}
    //     onClick={props?.type === "sticker" ? props?.handleClick : undefined}
    //     onLoad={onLoad}
    //     onError={onError}
    //   />
    // </div>
    <div
      style={{
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "106px",
        height: "106px",
        backgroundImage: `url("${imageSrc}")`,
        backgroundSize: "contain",
      }}
    />
  );
};
export default React.memo(StickerComment);
